export default {
  isDriverEligible: false
};
